import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultOccPriceDisplayText = {
    itemPriceFormat: '${price}',
    discountedPriceFormat: 'Now ${price}',
    percentageOffDiscountFormat: '${discount}% off',
    priceOffDiscountFormat: 'Save ${discount}',
    freeDiscountLabel: 'Free'
};
export const occPriceDisplayTextValidator = Validator.object({
    itemPriceFormat: nonEmptyStringValidator,
    discountedPriceFormat: nonEmptyStringValidator,
    percentageOffDiscountFormat: nonEmptyStringValidator,
    priceOffDiscountFormat: nonEmptyStringValidator,
    freeDiscountLabel: nonEmptyStringValidator
});
